import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Linking, Image, ScrollView } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles
import Sidebar from './sidebar';  // ✅ Import the new Sidebar
import Footer from './footer'; // ✅ Import Footer
import Header from './header'; // ✅ Import Footer

const Privacy = ({ navigation }) => {

  const [activeLink, setActiveLink] = useState('Privacy');

  const [showSidebar, setShowSidebar] = useState(false);

  const handleLinkPress = (screen) => {
    setShowSidebar(false); // Close sidebar on navigation
    navigation.navigate(screen);
  };

   const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <View style={styles.pageContainer}>
       {/* Fixed Header */}
      <View style={styles.fixedHeader}>
         <Header onToggleSidebar={toggleSidebar} />
      </View>

      {showSidebar && (
        <Sidebar
          activeLink={activeLink}
          handleLinkPress={handleLinkPress}
          onClose={() => setShowSidebar(false)}
        />
      )}

      {/* Scrollable Content */}
      <ScrollView contentContainerStyle={styles.scrollContainer}>

      {/* Main Content */}
      <View style={styles.mainContent}>
        <Text style={styles.heading}>Privacy Policy</Text>

        
        
         <View style={{ height: 20 }} /> 
      
       

       <View style={styles.imageWrapper}>
  <Image
    source={require('./assets/privacy.jpg')}
    style={styles.storyImage}
    resizeMode="cover"
  />
</View>

      
       <View style={{ height: 20 }} />

        <View style={styles.contactDetails}>
          <Text style={[styles.contactText, {  textAlign: 'left' }]}> At IntegrationX, we take your privacy seriously. We do not sell or share your personal data.
        All data collected is used solely to improve our services and provide a seamless experience.
        For any concerns, contact us at <Text style={styles.contactText}>privacy@integrationx.ai

        IntegrationX may change this Privacy Notice from time to time. We will post any changes on this page and, if we make material changes, provide a more prominent notice (for example, by adding a statement to the website landing page). If you disagree with any changes to this Privacy Policy, you should stop using the Services from us.
        </Text></Text>
          
        </View>
        <View style={{ height: 20 }} /> 

         <View style={styles.contactDetails}>
          <Text style={[styles.contactText, {  textAlign: 'left' }]}> Privacy Policy — Last updated: April 27, 2025
          </Text>
        </View>


        {/* Footer */}
        <Footer navigation={navigation} />
      </View>
      </ScrollView>
    </View>
  );
};


export default Privacy;
